import { IAgentModerationInfoSchema } from 'shared/repositories/offer-card/entities/agent/AgentModerationInfoSchema';

import { IState } from '../../store';

export const selectAgentModerationInfo = (state: IState): IAgentModerationInfoSchema | undefined | null => {
  return state.offerData.agent?.moderationInfo;
};
